import type { RfHub } from '@repo/shared/types/core/supabase';

export enum Theme {
	LIGHT = 'light',
	DARK = 'dark'
}

export enum DashboardDrawerState {
	EXPANDED = 'EXPANDED',
	COLLAPSED = 'COLLAPSED',
	EXPAND_ON_HOVER = 'EXPAND_ON_HOVER',
	NARROW = 'NARROW'
}

export enum ConfigureHubTab {
	GENERAL = 'GENERAL',
	APPEARANCE = 'APPEARANCE',
	STARTER_PROMPTS = 'STARTER_PROMPTS',
	ADDITIONAL_GUIDELINES = 'ADDITIONAL_GUIDELINES',
	AGENT_CONFIGURATION = 'AGENT_CONFIGURATION',
	SECURITY = 'SECURITY',
	RAW_JSON_EDITOR = 'RAW_JSON_EDITOR'
}

export enum AppearanceModeTab {
	GLOBAL = 'global_config',
	WIDGET = 'web_widget',
	WHITELABEL = 'whitelabel_domain'
}

export enum AgentQATriageTab {
	EVALUATION = 'EVALUATION',
	NOTES = 'NOTES',
	ACTIVITY_LOG = 'ACTIVITY_LOG',
	AUTO_EVAL = 'AUTO_EVAL'
}

export enum AgentQATriageQueryParam {
	QA_PANEL = 'qa-panel'
}

export enum AgentQATriageQueryParamValue {
	EVALUATION = 'evaluation',
	NOTES = 'notes',
	ACTIVITY_LOG = 'activity-log'
}

export enum ConversationHistoryExportFormat {
	EXCEL = 'EXCEL',
	PDF = 'PDF',
	HTML = 'HTML',
	MARKDOWN = 'MARKDOWN',
	JSON = 'JSON'
}

export interface DisplayModeConfig {
	isEmbeddedWidgetMode: boolean;
	isWhitelabelDomainMode: boolean;
	isSharedMode: boolean;
	isPreviewMode: boolean;
	isCatalogFilterMode: boolean;
	isReadonlyMode: boolean;
	isChromeExtensionMode: boolean;
}

/** The bot-protection config the widget runs on, already resolved off the hub bootstrap response's flat reCAPTCHA fields. */
export interface RecaptchaConfig extends Pick<RfHub, 'api_key' | 'api_key_type'> {
	recaptcha_site_key?: string | null;
	recaptcha_checkbox_site_key?: string | null;
	recaptcha_checkbox_key_enabled?: boolean | null;
}
